<template>
    <div>
<!--        <strong>{{ getActorName() }}</strong>-->
<!--        logged in to Supsis-->
        <span v-html="$t('notification.userLoggenIn', {user: getActorName()})"></span>
    </div>
</template>
<script>
import Vue from "vue";
import activityVisitorMaskMixin from "./activityVisitorMaskMixin";

export default Vue.extend({
    name: "UserLoggedIn",
    mixins: [activityVisitorMaskMixin],
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getActorName() {
            if (this.activity.actor === "user") {
                return this.$_.get(this.activity, "actorUser.name");
            } else if (this.activity.actor === "visitor") {
                return this.maskVisitorDisplayName(this.$_.get(this.activity, "refVisitor.fullname"));
            } else if (this.activity.actor === "chatbot") {
                return "Chatbot";
            } else if (this.activity.actor === "system") {
                return "System";
            }
        },
    },
});
</script>

<style scoped lang="scss"></style>
